// Cloudflare's officially documented widget script:
// https://developers.cloudflare.com/turnstile/get-started/client-side-rendering/
const TURNSTILE_SCRIPT_SRC =
  "https://challenges.cloudflare.com/turnstile/v0/api.js";

let scriptLoadingPromise = null;

export function loadTurnstileScript() {
  if (typeof window === "undefined") {
    return Promise.reject(
      new Error("Turnstile can only be loaded in the browser"),
    );
  }
  if (window.turnstile) {
    return Promise.resolve(window.turnstile);
  }
  if (scriptLoadingPromise) {
    return scriptLoadingPromise;
  }

  scriptLoadingPromise = new Promise((resolve, reject) => {
    window.__onTurnstileScriptLoad = () => {
      if (window.turnstile) {
        resolve(window.turnstile);
      } else {
        reject(
          new Error(
            "Turnstile script loaded but window.turnstile is unavailable",
          ),
        );
      }
    };

    const existingScript = document.querySelector(
      `script[src^="${TURNSTILE_SCRIPT_SRC}"]`,
    );
    if (existingScript) return; // another mount already kicked off loading

    const script = document.createElement("script");
    script.src = `${TURNSTILE_SCRIPT_SRC}?render=explicit&onload=__onTurnstileScriptLoad`;
    script.async = true;
    script.defer = true;
    script.onerror = () =>
      reject(new Error("Failed to load the Cloudflare Turnstile script"));
    document.head.appendChild(script);
  });

  return scriptLoadingPromise;
}
